import Vue from 'vue'
import Vuex from 'vuex'


import userInfo from './user/UserInfo'; //유저관리

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    userInfo,
  }
})
